/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';

export default function Overview({ data = {} }) {
  const { t } = useTranslation();
  const splits = data?.programDescription ? data.programDescription.split('\n') : [];

  return (
    <Widget
      className="with-border-header"
      title={t('Overview')}
    >
      <Style>
        <p>
          {splits.length ? splits.map((s, i) => (
            <React.Fragment key={i}>
              {s}
              {i !== splits.length - 1 ? <br /> : null}
            </React.Fragment>
          )) : '--'}
        </p>
      </Style>
    </Widget>
  )
}
